import { apiRequest } from "../lib/apiClient";
import type { BankStatementLineOut, CsvImportResponse, UnmatchedLineWithCandidatesOut } from "./types";

/** `POST /bank-reconciliation/import` — ACCOUNTANT-only, multipart (not JSON):
 * `account_id`/`branch_id` are `Form(...)` fields on the backend, not query params. */
export async function importBankStatement(
  accessToken: string,
  args: { accountId: string; branchId?: string; file: File },
): Promise<CsvImportResponse> {
  const formData = new FormData();
  formData.set("account_id", args.accountId);
  if (args.branchId) formData.set("branch_id", args.branchId);
  formData.set("file", args.file);
  return apiRequest<CsvImportResponse>("/bank-reconciliation/import", { method: "POST", accessToken, formData });
}

/** `GET /bank-reconciliation/unmatched?account_id=` — ACCOUNTANT-only. */
export async function listUnmatchedBankLines(accessToken: string, accountId: string): Promise<UnmatchedLineWithCandidatesOut[]> {
  return apiRequest<UnmatchedLineWithCandidatesOut[]>("/bank-reconciliation/unmatched", {
    accessToken,
    query: { account_id: accountId },
  });
}

/** `POST /bank-reconciliation/match` — ACCOUNTANT-only. */
export async function matchBankLine(
  accessToken: string,
  bankStatementLineId: string,
  transactionLegId: string,
): Promise<BankStatementLineOut> {
  return apiRequest<BankStatementLineOut>("/bank-reconciliation/match", {
    method: "POST",
    accessToken,
    body: { bank_statement_line_id: bankStatementLineId, transaction_leg_id: transactionLegId },
  });
}

/** `POST /bank-reconciliation/lines/{id}/unmatch` — ACCOUNTANT-only. */
export async function unmatchBankLine(accessToken: string, bankStatementLineId: string): Promise<BankStatementLineOut> {
  return apiRequest<BankStatementLineOut>(`/bank-reconciliation/lines/${bankStatementLineId}/unmatch`, {
    method: "POST",
    accessToken,
  });
}
